import React from 'react';
const VirtualBackground = (props: React.SVGProps<SVGSVGElement>) =>
(
    <svg
        width="800px"
        height="800px"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <rect x="4" y="3" width="16" height="18" rx="1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <circle cx="9.5" cy="8.5" r="1.5" fill="currentColor" />
        <path d="M7 17V15L9 12.5L11 14L14 11L17 15V17H7Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />

    </svg>
);
export default VirtualBackground;
